import { Component, input, output } from '@angular/core';


export type AlertType = 'success' | 'info' | 'warning' | 'danger';


@Component({
    selector: 'ui-alert',
    host: {
        '[animate.enter]': 'animation() ? "fade-enter" : ""',
        '[animate.leave]': 'animation() ? "fade-leave" : ""',
        '[class]': '"d-block alert alert-" + type() + " print-hidden mb-0"',
        '[class.alert-dismissible]': 'dismissible()',
        'role': 'alert',
    },
    template: `
        <ng-content></ng-content>
        @if (dismissible()) {
            <button type="button" class="close" title="Close" (click)="close.emit()">
                &times;
            </button>
        }
    `,
})
export class AlertComponent {

    type = input<AlertType>('info');

    dismissible = input(false);

    animation = input(true);

    close = output();
}
